module.exports = __webpack_public_path__ + "static/atlaskit-badge-inverted-684179c574741d93bc0a934768451b66.png";